var CenterAlignedContentWidth = /*#__PURE__*/function (CenterAlignedContentWidth) {
  CenterAlignedContentWidth[CenterAlignedContentWidth["ExtraLarge"] = 1320] = "ExtraLarge";
  CenterAlignedContentWidth[CenterAlignedContentWidth["Large"] = 960] = "Large";
  CenterAlignedContentWidth[CenterAlignedContentWidth["Medium"] = 720] = "Medium";
  CenterAlignedContentWidth["Adaptive"] = "100%";
  return CenterAlignedContentWidth;
}(CenterAlignedContentWidth || {});
var CenterAlignedContentMargins = /*#__PURE__*/function (CenterAlignedContentMargins) {
  CenterAlignedContentMargins[CenterAlignedContentMargins["ExtraLarge"] = 0] = "ExtraLarge";
  CenterAlignedContentMargins[CenterAlignedContentMargins["Large"] = 44] = "Large";
  CenterAlignedContentMargins[CenterAlignedContentMargins["Medium"] = 32] = "Medium";
  CenterAlignedContentMargins[CenterAlignedContentMargins["Small"] = 24] = "Small";
  return CenterAlignedContentMargins;
}(CenterAlignedContentMargins || {});
var Spacings = /*#__PURE__*/function (Spacings) {
  Spacings[Spacings["Size_1"] = 2] = "Size_1";
  Spacings[Spacings["Size_2"] = 4] = "Size_2";
  Spacings[Spacings["Size_3"] = 6] = "Size_3";
  Spacings[Spacings["Size_4"] = 8] = "Size_4";
  Spacings[Spacings["Size_5"] = 10] = "Size_5";
  Spacings[Spacings["Size_6"] = 12] = "Size_6";
  Spacings[Spacings["Size_7"] = 14] = "Size_7";
  Spacings[Spacings["Size_8"] = 16] = "Size_8";
  Spacings[Spacings["Size_9"] = 18] = "Size_9";
  Spacings[Spacings["Size_10"] = 20] = "Size_10";
  Spacings[Spacings["Size_11"] = 22] = "Size_11";
  Spacings[Spacings["Size_12"] = 24] = "Size_12";
  Spacings[Spacings["Size_13"] = 26] = "Size_13";
  Spacings[Spacings["Size_14"] = 28] = "Size_14";
  Spacings[Spacings["Size_15"] = 30] = "Size_15";
  Spacings[Spacings["Size_16"] = 32] = "Size_16";
  Spacings[Spacings["Size_17"] = 34] = "Size_17";
  Spacings[Spacings["Size_18"] = 36] = "Size_18";
  Spacings[Spacings["Size_19"] = 38] = "Size_19";
  Spacings[Spacings["Size_20"] = 40] = "Size_20";
  Spacings[Spacings["Size_21"] = 42] = "Size_21";
  Spacings[Spacings["Size_22"] = 44] = "Size_22";
  Spacings[Spacings["Size_23"] = 46] = "Size_23";
  Spacings[Spacings["Size_24"] = 48] = "Size_24";
  Spacings[Spacings["Size_25"] = 50] = "Size_25";
  Spacings[Spacings["Size_26"] = 52] = "Size_26";
  Spacings[Spacings["Size_27"] = 54] = "Size_27";
  Spacings[Spacings["Size_28"] = 56] = "Size_28";
  Spacings[Spacings["Size_29"] = 58] = "Size_29";
  Spacings[Spacings["Size_30"] = 60] = "Size_30";
  Spacings[Spacings["Size_31"] = 62] = "Size_31";
  Spacings[Spacings["Size_32"] = 64] = "Size_32";
  return Spacings;
}(Spacings || {});
var BorderRadiuses = /*#__PURE__*/function (BorderRadiuses) {
  BorderRadiuses[BorderRadiuses["Size_1"] = 2] = "Size_1";
  BorderRadiuses[BorderRadiuses["Size_2"] = 4] = "Size_2";
  BorderRadiuses[BorderRadiuses["Size_3"] = 6] = "Size_3";
  BorderRadiuses[BorderRadiuses["Size_4"] = 8] = "Size_4";
  BorderRadiuses[BorderRadiuses["Size_5"] = 10] = "Size_5";
  BorderRadiuses[BorderRadiuses["Size_6"] = 12] = "Size_6";
  BorderRadiuses[BorderRadiuses["Size_7"] = 14] = "Size_7";
  BorderRadiuses[BorderRadiuses["Size_8"] = 16] = "Size_8";
  BorderRadiuses[BorderRadiuses["Size_9"] = 18] = "Size_9";
  BorderRadiuses[BorderRadiuses["Size_10"] = 20] = "Size_10";
  BorderRadiuses[BorderRadiuses["Size_11"] = 22] = "Size_11";
  BorderRadiuses[BorderRadiuses["Size_12"] = 24] = "Size_12";
  BorderRadiuses[BorderRadiuses["Size_13"] = 26] = "Size_13";
  BorderRadiuses[BorderRadiuses["Size_14"] = 28] = "Size_14";
  BorderRadiuses[BorderRadiuses["Size_15"] = 30] = "Size_15";
  BorderRadiuses[BorderRadiuses["Size_16"] = 32] = "Size_16";
  BorderRadiuses[BorderRadiuses["Size_17"] = 34] = "Size_17";
  BorderRadiuses[BorderRadiuses["Size_18"] = 36] = "Size_18";
  BorderRadiuses[BorderRadiuses["Size_19"] = 38] = "Size_19";
  BorderRadiuses[BorderRadiuses["Size_20"] = 40] = "Size_20";
  BorderRadiuses[BorderRadiuses["Size_21"] = 42] = "Size_21";
  BorderRadiuses[BorderRadiuses["Size_22"] = 44] = "Size_22";
  BorderRadiuses[BorderRadiuses["Size_23"] = 46] = "Size_23";
  BorderRadiuses[BorderRadiuses["Size_24"] = 48] = "Size_24";
  BorderRadiuses[BorderRadiuses["Size_25"] = 50] = "Size_25";
  BorderRadiuses[BorderRadiuses["Size_26"] = 52] = "Size_26";
  BorderRadiuses[BorderRadiuses["Size_27"] = 54] = "Size_27";
  BorderRadiuses[BorderRadiuses["Size_28"] = 56] = "Size_28";
  BorderRadiuses[BorderRadiuses["Size_29"] = 58] = "Size_29";
  BorderRadiuses[BorderRadiuses["Size_30"] = 60] = "Size_30";
  BorderRadiuses[BorderRadiuses["Size_31"] = 62] = "Size_31";
  BorderRadiuses[BorderRadiuses["Size_32"] = 64] = "Size_32";
  return BorderRadiuses;
}(BorderRadiuses || {});
var Transitions = /*#__PURE__*/function (Transitions) {
  Transitions["Fast"] = "0.1s";
  Transitions["Default"] = "0.3s";
  Transitions["Medium"] = "0.5s";
  Transitions["DropDown"] = "0.46s";
  Transitions["Long"] = "1s";
  return Transitions;
}(Transitions || {});
var BreakPoints = {
  ExtraLarge: 1365,
  Large: 1023,
  Medium: 767,
  Small: 766
};
var AspectRatioDimensions = /*#__PURE__*/function (AspectRatioDimensions) {
  AspectRatioDimensions["Full"] = "100%";
  AspectRatioDimensions["HD"] = "56.25%";
  AspectRatioDimensions["Standard"] = "75%";
  AspectRatioDimensions["Classic"] = "66.6%";
  AspectRatioDimensions["CinemaScope"] = "42.8%";
  return AspectRatioDimensions;
}(AspectRatioDimensions || {}); // 21:9
// ToDo REMOVE ALL UNDERLYING
// ##############################################################
// DEPRECATED START - Must be removed
// ##############################################################
var OldBreakPoints = /*#__PURE__*/function (OldBreakPoints) {
  OldBreakPoints[OldBreakPoints["xsmall"] = 375] = "xsmall";
  OldBreakPoints[OldBreakPoints["xlsmall"] = 576] = "xlsmall";
  OldBreakPoints[OldBreakPoints["small"] = 768] = "small";
  OldBreakPoints[OldBreakPoints["medium"] = 1024] = "medium";
  OldBreakPoints[OldBreakPoints["large"] = 1281] = "large";
  OldBreakPoints[OldBreakPoints["xlarge"] = 1366] = "xlarge";
  OldBreakPoints[OldBreakPoints["xxlarge"] = 1600] = "xxlarge";
  return OldBreakPoints;
}(OldBreakPoints || {}); // ##############################################################

export { AspectRatioDimensions, BorderRadiuses, BreakPoints, CenterAlignedContentMargins, CenterAlignedContentWidth, OldBreakPoints, Spacings, Transitions };
//# sourceMappingURL=index.js.map
